export default "__VITE_ASSET__DwJ70iEc__"